import React from "react"
import { AppBar, Container, Grid, Grow, Paper, styled } from "@mui/material"
import { useDispatch } from "react-redux"
import { getPostBySearch } from "../../features/posts/postSlice"
import Form from "../Form/Form"
import AllPosts from "./AllPosts"
import PaginationBlock from "../PaginationBlock"
import { useNavigate, useLocation } from "react-router-dom"
import SearchComponent from "../SearchComponent"

const GridStyled = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down("xs")]: {
    flexDirection: "column-reverse",
  },
}))
const AppBarStyled = styled(AppBar)({
  borderRadius: 4,
  marginBottom: "1rem",
  display: "flex",
  padding: "16px",
})

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

const MainPosts = () => {
  const navigate = useNavigate()
  const [currentId, setCurrentId] = React.useState(null)
  const [search, setSearch] = React.useState("")
  const dispatch = useDispatch()
  const query = useQuery()
  const page = query.get("page") || 1
  const searchQuery = query.get("searchQuery")

  const searchPost = () => {
    if (search.trim()) {
      dispatch(getPostBySearch({ search }))
      navigate(`/posts/search/?q=${search}`)
      setSearch("")
    } else {
      navigate("/")
      setSearch("")
    }
  }

  const onSubmit = (e) => {
    e.preventDefault()
    searchPost()
  }

  return (
    <Grow in>
      <Container maxWidth="xl">
        <GridStyled
          container
          alignItems="stretch"
          spacing={3}
          justifyContent="space-between"
        >
          <Grid item xs={12} sm={6} md={9}>
            <AllPosts setCurrentId={setCurrentId} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppBarStyled position="static" color="inherit">
              <SearchComponent
                onSubmit={onSubmit}
                search={search}
                setSearch={setSearch}
              />
            </AppBarStyled>
            <Form currentId={currentId} setCurrentId={setCurrentId} />
            {!searchQuery && (
              <Paper elevation={6} sx={{ marginY: 2 }}>
                <PaginationBlock page={page} />
              </Paper>
            )}
          </Grid>
        </GridStyled>
      </Container>
    </Grow>
  )
}
export default MainPosts
